import React from "react";
import { useParams } from "react-router-dom";
import { useBulkMessage } from "@/hooks/useBulkMessage";
import { SendBulkMessage } from "./SendBulkMessage";
import { transformIntoFormData } from "./utils/apiHelpers";
import { useNow } from "@/hooks/useNow";
import { useUpdateBulkMessage } from "@/hooks/useUpdateBulkMessage";
import { FormValues } from "./types";
import { Spinner } from "@/assets/svg/Spinner";
import { isActive } from "./utils/sentStatus";
import { useOrgTimeZone } from "@/hooks/useOrgTimeZone";

export function EditBulkMessage() {
  const { bulkMessageId } = useParams();
  const now = useNow();

  const { data, loading: bulkMessageLoading } = useBulkMessage(bulkMessageId);
  const { timeZone, loading: loadingTimeZone } = useOrgTimeZone();

  const [
    updateBulkMessage,
    { loading: updateLoading, data: updateData, error },
  ] = useUpdateBulkMessage();

  const submitForm = (values: FormValues, { draft = false }) => {
    if (!bulkMessageId) {
      return;
    }

    return updateBulkMessage({
      formValues: values,
      bulkMessageId,
      draft,
    });
  };

  return bulkMessageLoading || loadingTimeZone ? (
    <Spinner />
  ) : (
    <SendBulkMessage
      submissionData={updateData}
      loading={updateLoading || bulkMessageLoading}
      isActive={isActive(data, now)}
      formValues={transformIntoFormData(data, {
        timeZone: timeZone,
        edit: true,
      })}
      askSaveDraft={!data?.draft}
      submitHandler={submitForm}
      error={error}
      bulkMessageId={bulkMessageId}
    />
  );
}
